var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconAscendingOrder18 = function SvgIconAscendingOrder18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m13.91 13.717-5.35.019-.005-1.125 5.352-.019.004 1.125ZM11.175 9.45H8.557V8.323h2.618V9.45ZM12.739 11.586H8.556V10.46h4.181v1.125ZM7.328 4.525v9.225H6.053V4.525h1.275Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m6.69 4.972-2.134 2.24-.923-.88L5.9 3.952a1.086 1.086 0 0 1 1.578 0l2.268 2.38-.923.88-2.134-2.24Z",
    fill: "current"
  })));
};
export default SvgIconAscendingOrder18;